<mat-list>
  @for (ministry of ministries; track ministry) {
    <mat-list-item>
      <!--  <img matListAvatar [src]="subscription.ministryAvatar">-->
      <a matListItemTitle [routerLink]="'/' + ministry.username" matLine>{{ ministry.name }}</a>
      @if (followable) {
        <zwi-subscribe-button matListItemMeta [ministry]="ministry" (subscribeChange)="changeSubscription($event)"></zwi-subscribe-button>
      }
    </mat-list-item>
  }
</mat-list>
